module.exports = __webpack_public_path__ + "static/img/mdh.73cde52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/responsibility/mdh.jpg
// module id = ZLg/
// module chunks = 0